import Api from "./Api";

export default {
  masterUpload(payload) {
    let docPath = Api().post(
      "Api_ProformaInvoices/allMaster.php",
      payload
    );
    return docPath;
  },
  ConsoleBooking(payload) {
    let docPath = Api().post(
      "Api_ConsoleBooking/getAlllExcelConsoleBooking.php",
      payload
    );
    return docPath;
  },
  sendSlinePayment(payload) {
    let docPath = Api().post(
      "CCExport_Slinepayment_remidercron2_Test.php",
      payload
    );
    return docPath;
  },
  activeMultipleDetails(payload) {
    let docPath = Api().post(
      "Api_Master/deletemultipledetails.php",
      payload
    );
    return docPath;
  },
  getFreightEnqPriceing(payload) {
    let docPath = Api().post(
      "Api_EnqPricing/getFreightEnquiryPriceing.php",
      payload
    );
    return docPath;
  },
};



// WEBPACK FOOTER //
// ./src/services/MasterService.js